import EventBus from '@/plugins/EventBus'
import { SolicitacaoComentario } from '@/types/_'
import moment from 'moment'
import { Component, Vue } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import { getUser } from '@/utils/common'
import chatSolicitacaoComentarioModule from './chat-solicitacao-comentario.module'
import ChatSolicitacaoComentarioStore from './store/chat-solicitacao-comentario-store'

@Component({
  components: chatSolicitacaoComentarioModule.components,
})
export default class ComponentChatSolicitacaoComentario extends Vue {
  canShowRightPanel = true
  toggleButton: any = 'comentario'

  fb: boolean = false
  lembrete0: boolean = false
  lembrete24h: boolean = false
  lembrete48h: boolean = false
  lembrete72h: boolean = false
  lembrete7dias: boolean = false
  lembrete10dias: boolean = false

  get active0() {
    return this.lembrete0
  }

  set active0(value: boolean) {
    this.lembrete0 = value
  }

  get active24() {
    return this.lembrete24h
  }

  set active24(value: boolean) {
    this.lembrete24h = value
  }

  get active48() {
    return this.lembrete48h
  }

  set active48(value: boolean) {
    this.lembrete48h = value
  }

  get active72() {
    return this.lembrete72h
  }

  set active72(value: boolean) {
    this.lembrete72h = value
  }

  get activeSeteDias() {
    return this.lembrete7dias
  }

  set activeSeteDias(value: boolean) {
    this.lembrete7dias = value
  }

  get activeDezDias() {
    return this.lembrete10dias
  }

  set activeDezDias(value: boolean) {
    this.lembrete10dias = value
  }

  get chatSolicitacaoComentarioStore() {
    return getModule(ChatSolicitacaoComentarioStore, this.$store)
  }

  send(value: string) {
    const user = getUser()
    const comentario = {
      texto: value,
      usuarioNome: user.profile.name,
      dataEnvio: moment().toISOString(),
    }

    this.chatSolicitacaoComentarioStore.sendComentario(comentario)
  }

  getMessageType() {
    return 'message'
  }

  getMessageSide() {
    return 'center'
  }

  async close() {
    this.toggleButton = 'comentario'
    this.fab = false
    await this.chatSolicitacaoComentarioStore.closeChatModal()
  }

  toggleRightPanel() {
    this.canShowRightPanel = !this.canShowRightPanel
  }

  getCanShowFooter(data: SolicitacaoComentario) {
    return false
  }

  getSenderName(data: SolicitacaoComentario) {
    return data.usuarioNome
  }

  getTexto(data: SolicitacaoComentario) {
    if (data.lembreteConcluido === true) {
      const style = 'style="color: #00ff0c; font-size: 18px; margin-left: 3px; border: 2px white solid; border-radius: 20px;'
      return `${data.texto} <i class="fa fa-check-circle" aria-hidden="true" title="Lembrete concluido" ${style}"></i>`
    }

    if (data.lembreteConcluido === false) {
      const style = 'style="color: #fbc02d; font-size: 18px; margin-left: 3px; border: 2px white solid; border-radius: 20px;"'
      return `${data.texto} <i class="fa fa-exclamation-circle" aria-hidden="true" title="${this.tempoRestante(data.lembreteData)}" ${style} ></i>`
    }

    return data.texto
  }

  getMessageContentStyle(data: SolicitacaoComentario) {
    if (data.tipo === 'Erro') {
      return 'background-color: #f66e6e'
    }

    if (data.tipo === 'CriticaOperadora') {
      return 'background-color: #EF8C01'
    }

    if (data.tipo === 'ErroIntegracaoOperadora') {
      return 'background-color: #CE5555'
    }

    return ''
  }

  getComentarios(tipo: string) {
    this.chatSolicitacaoComentarioStore.loadChatData(tipo)
  }

  get utilizaExibicaoDeHistoricoAutorizacao() {
    return this.chatSolicitacaoComentarioStore.utilizaExibicaoDeHistoricoAutorizacao
  }

  get possuiComentariosErrosIntegracaoOperadora() {
    return this.surgerySolicitationActions && this.surgerySolicitationActions.possuiComentariosErrosIntegracaoOperadora
  }

  get possuiComentariosCriticaIntegracaoOperadora() {
    return this.surgerySolicitationActions && this.surgerySolicitationActions.possuiComentariosCriticaIntegracaoOperadora
  }

  get surgerySolicitationActions() {
    return this.chatSolicitacaoComentarioStore.acoes
  }

  async enviarLembrete(horas: number) {
    this.fab = false
    switch (horas) {
      case 0:
        this.active0 = true
        this.active24 = true
        this.active48 = false
        this.active72 = false
        this.activeSeteDias = false
        this.activeDezDias = false
        break
      case 24:
        this.active0 = true
        this.active24 = true
        this.active48 = false
        this.active72 = false
        this.activeSeteDias = false
        this.activeDezDias = false
        break
      case 48:
        this.active0 = false
        this.active24 = false
        this.active48 = true
        this.active72 = false
        this.activeSeteDias = false
        this.activeDezDias = false
        break
      case 72:
        this.active0 = false
        this.active24 = false
        this.active48 = false
        this.active72 = true
        this.activeSeteDias = false
        this.activeDezDias = false
        break
      case 168:
        this.active0 = false
        this.active24 = false
        this.active48 = false
        this.active72 = false
        this.activeSeteDias = true
        this.activeDezDias = false
        break
      case 240:
        this.active0 = false
        this.active24 = false
        this.active48 = false
        this.active72 = false
        this.activeSeteDias = false
        this.activeDezDias = true
        break
      default:
        return false
    }

    const params: any = {
      solicitacaoId: this.chatSolicitacaoComentarioStore.solicitacaoId,
      lembretePrazo: horas,
    }

    const lembreteConcluidoPeloUsuario = horas === 0
    const response = lembreteConcluidoPeloUsuario
      ? await this.chatSolicitacaoComentarioStore.concluirLembrete()
      : await this.chatSolicitacaoComentarioStore.enviarLembrete(params)

    if (response.success) {
      EventBus.$emit('setLembrete', {
        solicitacaoId: this.chatSolicitacaoComentarioStore.solicitacaoId,
        concluido: lembreteConcluidoPeloUsuario,
      })

      await this.chatSolicitacaoComentarioStore.loadChatData('comentario')
    }

    return false
  }

  tempoRestante(dataFinal: any) {
    const endTime = moment(dataFinal)
    const duration = Math.floor(moment.duration(endTime.diff(moment())).asHours())
    return duration <= 1
      ? `${duration} hora para a conclusão deste lembrete`
      : `${duration} horas para a conclusão deste lembrete`
  }

  getBadge(data: SolicitacaoComentario) {
    const badge = { showBadge: false, badgeIcon: 'check_circle', badgeColor: 'green darken-2', badgeText: 'Lembrete concluído' }
    if (data.lembreteConcluido === true) {
      badge.showBadge = true
      badge.badgeIcon = 'check_circle'
      badge.badgeColor = 'green darken-2'
      badge.badgeText = 'Lembrete concluído'
    } else if (data.lembreteConcluido === false) {
      badge.showBadge = true
      badge.badgeIcon = 'las la-exclamation-circle'
      badge.badgeColor = 'yellow darken-2'
      badge.badgeText = this.tempoRestante(data.lembreteData)
    }

    return badge
  }

  get solicitacaoTemLembreteAtivo() {
    return this.chatSolicitacaoComentarioStore.comentarios.some((comentario: any) => comentario.lembreteConcluido === false)
  }

  get fab() {
    return this.fb
  }

  set fab(value: boolean) {
    this.fb = value
  }
}
